/**
 * Card de opt-in de notificaciones (Web Push). Se muestra en Réditos.
 *
 * Flujo INTELIGENTE por plataforma (la base — el rediseño UX la elevará después):
 *   - No soportado → no se muestra.
 *   - Ya activado (permiso granted) → no se muestra (ya está).
 *   - iOS sin instalar → guía a "agregar al inicio" primero (push iOS exige PWA instalada).
 *   - Resto → botón "Activar avisos" que pide permiso y suscribe.
 *
 * Copy positivo, vendido como "no te pierdas cuando cobrás" (FOMO sano).
 */
import { t } from '../languages.js';
import {
    activarNotificaciones,
    estadoPermiso,
    pushSoportado,
    esIOS,
    esStandalone,
} from '../push-notificaciones.js';

/**
 * Devuelve el elemento de la card, o null si no corresponde mostrarla.
 * @returns {HTMLElement|null}
 */
export function renderCardNotificaciones() {
    if (!pushSoportado()) return null;
    const permiso = estadoPermiso();
    if (permiso === 'granted') return null; // ya activado → no molestar

    const card = document.createElement('div');
    card.className = 'card';
    card.style.cssText =
        'background:rgba(240,192,64,0.08); border:1px solid rgba(240,192,64,0.3); margin-bottom:10px;';

    // iOS sin instalar: el push exige la PWA en el inicio → guiamos a eso primero.
    if (esIOS() && !esStandalone()) {
        card.innerHTML = `
            <div style="font-weight:700; margin-bottom:4px;">${t('notif.tituloIOS')}</div>
            <div style="font-size:14px; color:var(--text-dim);">${t('notif.guiaIOS')}</div>`;
        return card;
    }

    if (permiso === 'denied') {
        // El usuario bloqueó el permiso nativo: no se puede re-pedir, solo guiar.
        card.innerHTML = `
            <div style="font-weight:700; margin-bottom:4px;">${t('notif.tituloBloqueado')}</div>
            <div style="font-size:14px; color:var(--text-dim);">${t('notif.guiaBloqueado')}</div>`;
        return card;
    }

    // Caso normal: botón para activar.
    card.innerHTML = `
        <div style="font-weight:700; margin-bottom:4px;">${t('notif.titulo')}</div>
        <div style="font-size:14px; color:var(--text-dim); margin-bottom:10px;">${t('notif.descripcion')}</div>
        <button id="pm-activar-notif" class="btn" style="background:var(--gold,#f0c040); color:#1a1a1a; font-weight:700;">
            ${t('notif.boton')}
        </button>
        <div id="pm-notif-estado" style="font-size:14px; color:var(--text-dim); margin-top:8px;"></div>`;

    const btn = card.querySelector('#pm-activar-notif');
    const estadoEl = card.querySelector('#pm-notif-estado');
    btn.addEventListener('click', async () => {
        btn.disabled = true;
        estadoEl.textContent = t('notif.activando');
        const res = await activarNotificaciones();
        if (res.ok) {
            // Reemplazar la card por una confirmación breve y sacarla.
            card.innerHTML = `<div style="color:var(--success); font-weight:700;">${t('notif.listo')}</div>`;
            setTimeout(() => card.remove(), 2500);
        } else if (res.estado === 'ios-requiere-instalar') {
            estadoEl.textContent = t('notif.guiaIOS');
            btn.disabled = false;
        } else if (res.estado === 'denegado') {
            estadoEl.textContent = t('notif.guiaBloqueado');
        } else {
            estadoEl.textContent = t('notif.error');
            btn.disabled = false;
        }
    });

    return card;
}
